// A skeleton for a single product card
const ProductCardSkeleton = () => (
  <div
    className="card placeholder-glow"
    style={{ minWidth: '270px', border: 'none', background: 'transparent' }}
  >
    <div
      className="placeholder"
      style={{ height: '230px', width: '100%', borderRadius: '12px' }}
    ></div>
    <div className="card-body px-0">
      <span className="placeholder col-10"></span>
      <span className="placeholder col-6 mt-2"></span>
      <span className="placeholder col-8 mt-3"></span>
    </div>
  </div>
);

// The main skeleton for the entire section
export const RecommendedForYouSkeleton = ({
  showBtn,
}: {
  showBtn?: boolean;
}) => {
  return (
    <section className="product-feature padding-top padding-bottom">
      <div className="container">
        {/* Skeleton Header */}
        <div className="section-header">
          <div className="section-header__content">
            <h2
              className="placeholder "
              style={{ width: '300px', height: '24px', borderRadius: '8px' }}
            ></h2>
          </div>
          {showBtn && (
            <div className="product-btn order-sm-2 order-lg-3">
              <div
                className="placeholder"
                style={{ width: '100px', height: '44px', borderRadius: '8px' }}
              ></div>
            </div>
          )}
        </div>

        {/* Skeleton Slider Body */}
        <div className="d-flex gap-4 overflow-hidden">
          {[...Array(5)].map((_, i) => (
            <ProductCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
